import { FC, useMemo } from 'react';
import styled from 'styled-components';
import { FormField, FormSelect } from '../../../common/form';
import { getAlgorithmSourceLabel } from '../utils';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmJoinSourceField.translations.json';
import { useUsedAlgorithmSourceIds } from './useUsedAlgorithmSourceIds';
import { AlgorithmJoinsFormStore } from './AlgorithmJoinsFormStore';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-join-source-field'
);
addTranslations(translations);

export interface AlgorithmJoinSourceFieldProps {
  index: number;
  onChange?: () => void;
}

export const AlgorithmJoinSourceSelectField: FC<
  AlgorithmJoinSourceFieldProps
> = (props) => {
  const { index, onChange } = props;
  const { t } = useTranslation();

  const [sources] = AlgorithmJoinsFormStore.useValue('sources');

  const usedAlgorithmSourceIds = useUsedAlgorithmSourceIds({
    excludeIndex: index,
  });

  const options = useMemo(
    () =>
      sources
        .filter((s) => !usedAlgorithmSourceIds.includes(s['id']))
        .map((s) => ({
          value: s['id'],
          label: getAlgorithmSourceLabel(s),
        })),
    [sources, usedAlgorithmSourceIds]
  );

  const name = `joins.${index}.algorithmSourceId`;

  return (
    <StyledFormField required name={name} label={t('label')}>
      <FormSelect
        name={name}
        allowClear
        placeholder={t('placeholder')}
        options={options}
        onChange={onChange}
      />
    </StyledFormField>
  );
};

const StyledFormField = styled(FormField)`
  min-width: 0;
`;
